import React, { useEffect, useState } from "react";
import apiRequest from "../../functions/api";
import {
    Typography,
    Grid,
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    CircularProgress,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    FormControlLabel,
    Checkbox,
    Button,
    useMediaQuery,
    useTheme,
    DialogActions,
} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useTranslation } from "react-i18next";
import { useMessage } from "../../context/message-context";
import { useLocalStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';



function MasterKinderComponent(props) {
    const { t } = useTranslation();
    const { user, accessToken, bearbeitung, daten, setReload, client, kinderBeantragen,showKinder ,reloadDaten} = props
    const [isLoading, setIsLoading] = useState(false);
    const [kinder, setKinder] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [priv] = useLocalStorage(LOCAL_STORAGE_KEY.private);
    const { showErrorMessage, showSuccessMessage } = useMessage();
    const [vorname, setVorname] = useState('');
    const [nachname, setNachname] = useState('');
    const [geburtsdatum, setGeburtsdatum] = useState('');
    const [dokument, setDokument] = useState('');
    const [delKind, setDelKind] = useState("");
    const [dokumentData, setDokumentData] = useState('');
    const [confiremDel, setConfirmDel] = useState(false);
    const [terms, setTerms] = useState(false);
    const program = "LWEB02"
    const theme = useTheme();
    var isDarkMode = false
    if (theme.palette.mode === "light") {
        isDarkMode = false
    } else {
        isDarkMode = true
    }
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
    const [state, setState] = useState(false)

    useEffect(() => {
        setKinder(daten)
    }, [daten])

    useEffect(() => {
        setReload(state)
    }, [state])


    const closeDialog = () => {
        setDialogOpen(false)
        setVorname("")
        setNachname("")
        setGeburtsdatum("")
        setDokument("")
        setTerms(false);
    }

    const handleFile = (event) => {
        setDokument(event.target.value)
        setDokumentData(event.target.files[0]);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const kindDaten = {
            vorname,
            nachname,
            geburtsdatum,
            dokument,
            terms,
        }

        setIsLoading(true);
        const payload = {
            program: program,
            statement: "KIND_HINZU",
            mandant: client,
            personalnummer: user.pnr,
            userId: user.id,
            kindDaten: kindDaten
        };
        const formData = new FormData();
        formData.append("payload", JSON.stringify(payload));
        formData.append('file', dokumentData,);

        const headers = {
            Authorization: "Bearer " + accessToken,
        };
        apiRequest("POST", "daten", formData, headers, submitCB);
    };

    const submitCB = (response) => {
        closeDialog();
        setIsLoading(false)
        reloadDaten()

        if (response?.data.message === "Kind bereits vorhanden") {
            showErrorMessage(response.data.message)
        }
        console.log(response)
        if (response.status === 200) {
            showSuccessMessage("Kind erfolgreich gemeldet")
        } else {
            if (response) {
                showErrorMessage(response.data.message);
            } else {
                showErrorMessage(t("Keine Internetverbindung"));
            }
        }
    }

    const deleteChild = (event) => {
        setConfirmDel(false);
        event.stopPropagation();

        const payload = {
            "mandant": client,
            "program": program,
            "personalnummer": user.pnr,
            "kindDaten": delKind,
            "statement": "KIND_DELETE",
        };
        const headers = {
            "Authorization": "Bearer " + accessToken,
        };
        apiRequest("POST", "daten", payload, headers, kindDeleteCb);

    }

    const kindDeleteCb = (response) => {

        if (response.status === 200) {
            showSuccessMessage("Löschen erfolgreich")
            
            reloadDaten()
        } else {
            if (response) {
                showErrorMessage(response.data.message);
            } else {
                showErrorMessage(t("Keine Internetverbindung"));
            }
        }
    }

    const KinderAccordion = () => {

        return (

            <TableBody>

                {kinder?.map((kind, index) => {
                    var kindKey = "Kind " + (index + 1)
                    const isNotApproved = kind.prfkz === "0"
                    return (
                        <>
                            <Accordion
                                disableGutters
                                sx={{
                                    backgroundColor: isNotApproved
                                        ? isDarkMode
                                            ? theme.palette.grey[800]
                                            : theme.palette.grey[200]
                                        : 'inherit',
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ArrowDownwardIcon />}
                                >
                                    <Grid item xs={12}>
                                        <TableContainer>
                                            <Table>
                                                <TableBody>
                                                    <TableRow key={kindKey}>
                                                        <TableCell>
                                                            <Typography variant="body2">
                                                                {kind.vorname + " " + kind.name}
                                                                {isNotApproved &&
                                                                    t(" (Noch nicht von der Personalabteilung bestätigt)")
                                                                }
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {isNotApproved &&
                                                                <IconButton onClick={(event) => {
                                                                    event.stopPropagation()
                                                                    setDelKind(kind)
                                                                    setConfirmDel(true)
                                                                }}
                                                                ><DeleteIcon /></IconButton>
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid item xs={12} >
                                        <TableContainer>
                                            <Table>
                                                <TableBody>
                                                    <TableRow key={"vorname"}>
                                                        <TableCell size={"small"}>
                                                            <Typography variant="body2">
                                                                {t("Vorname")}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Typography variant="body2">
                                                                {kind.vorname}
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow key={"nachname"}>
                                                        <TableCell>
                                                            <Typography variant="body2">
                                                                {t("Nachname")}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Typography variant="body2">
                                                                {kind.name}
                                                            </Typography>
                                                        </TableCell>

                                                    </TableRow>
                                                    <TableRow key={"gebdat"}>
                                                        <TableCell>
                                                            <Typography variant="body2">
                                                                {t("Geburtsdatum")}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Typography variant="body2">
                                                                {kind.gebdat}
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                            <Dialog
                                open={confiremDel}
                                onClose={() => setConfirmDel(false)}
                            >
                                <DialogTitle>{t("Wollen sie das beantragte Kind wirklich löschen?")}</DialogTitle>
                                <DialogActions>
                                    <Button onClick={() => setConfirmDel(false)}>{t("Nein")}</Button>
                                    <Button onClick={(e) => deleteChild(e)}>{t("Ja")}</Button>

                                </DialogActions>
                            </Dialog>
                        </>
                    )

                })}

                {!kinder &&
                    <div>
                        {t("Noch keine Kinder gemeldet")}
                    </div>
                }


            </TableBody>

        )
    }

    const AddNewChild = () => {

        return (
            <Box
                component="form"
                sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 400, margin: 'auto', padding: 2 }}
                onSubmit={handleSubmit}
            >
                <TextField
                    label="Vorname"
                    name="vorname"
                    value={vorname}
                    onChange={(e) => setVorname(e.target.value)}
                    required
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextField
                    label="Nachname"
                    name="nachname"
                    value={nachname}
                    onChange={(e) => setNachname(e.target.value)}
                    required
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextField
                    label="Geburtsdatum"
                    name="geburtsdatum"
                    type="date"
                    value={geburtsdatum}
                    onChange={(e) => setGeburtsdatum(e.target.value)}
                    required
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextField
                    label="Nachweis Dokument ablegen"
                    name="dokument"
                    type="file"
                    value={dokument}
                    onChange={(e) => handleFile(e)}
                    required
                    inputProps={{ accept: 'application/pdf' }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            name="terms"
                            checked={terms}
                            onChange={(e) => setTerms(e.target.checked)}
                            required
                        />
                    }
                    label="Ich versichere Ihnen, dass ich die Angaben in diesem Vordruck wahrheitsgemäß nach bestem Wissen und Gewissen vorgenommen habe und jegliche Änderung unverzüglich mitteilen werde."
                />
                <Box paddingTop={2} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <Button onClick={() => setDialogOpen(false)}>Abbrechen</Button>
                    <Button type="submit" variant="contained" color="primary"> Submit</Button>
                </Box>

            </Box>

        )
    }


    return (
        <>
            {isLoading ? (
                <Grid item xs={12}>
                    <CircularProgress />
                </Grid>
            ) :
                (
                    <Grid item>
                        <Grid container spacing={0.5}>
                            <Grid item xs={12} >
                                <Paper>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow key="kinder">
                                                    <TableCell>
                                                        <Box sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            padding: 1

                                                        }}>
                                                            <Typography>{t("Gemeldete Kinder")}</Typography>
                                                            {kinderBeantragen  && <IconButton onClick={() => { setDialogOpen(true) }}><AddIcon /></IconButton>}
                                                        </Box>

                                                    </TableCell>

                                                </TableRow>
                                            </TableHead>
                                            {KinderAccordion()}
                                        </Table >

                                    </TableContainer >
                                </Paper >
                            </Grid>

                        </Grid>


                        <Dialog
                            sx={{ '& .MuiDialog-paper': { width: '95%', maxHeight: 650 } }}
                            fullScreen={fullScreen}
                            open={dialogOpen}
                            onClose={() => closeDialog()}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    position: 'relative',  // Relative position to allow absolute positioning of the centered box
                                    height: '56px',        // Set a height to align items vertically in the center
                                    paddingLeft: ""
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        left: '25%',
                                        transform: 'translateX(-50%)',
                                    }}
                                >
                                    <DialogTitle sx={{ display: 'center' }}>Kind hinzufügen</DialogTitle>
                                </Box>
                            </Box>


                            <DialogContent dividers>
                                {AddNewChild()}
                            </DialogContent>

                        </Dialog>

                    </Grid>


                )}
        </>
    )
}




export default MasterKinderComponent